var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefresh(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.77778 8C1.77778 4.56401 4.56401 1.77778 8 1.77778C9.69633 1.77778 11.2324 2.45377 12.3563 3.55556H10.6667C10.1757 3.55556 9.77778 3.95352 9.77778 4.44444C9.77778 4.93536 10.1757 5.33333 10.6667 5.33333H14.2222C14.7131 5.33333 15.1111 4.93536 15.1111 4.44444V0.888889C15.1111 0.397969 14.7131 0 14.2222 0C13.7313 0 13.3333 0.397969 13.3333 0.888889V2.03552C11.9176 0.76895 10.0477 0 8 0C3.58217 0 0 3.58217 0 8C0 12.4178 3.58217 16 8 16C12.4178 16 16 12.4178 16 8C16 7.50908 15.602 7.11111 15.1111 7.11111C14.6202 7.11111 14.2222 7.50908 14.2222 8C14.2222 11.436 11.436 14.2222 8 14.2222C4.56401 14.2222 1.77778 11.436 1.77778 8Z",
    fill: "#4D4D4D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefresh);
export default __webpack_public_path__ + "static/media/refresh.a470fa8ec8757904068cc7c37d97b938.svg";
export { ForwardRef as ReactComponent };